import React from 'react';
import './CharityAmount.scss';
import { useDispatch, useSelector } from 'react-redux';
import { currency, currencyNoPrecision } from '../../../utils/utils';
import {
  getCharitiesArray,
  getCharitiesTotalGrossAmount,
} from '../../../redux/modules/qcd/qcd.selectors';
import { AddGrossAmount } from '../../../redux/modules/qcd/qcd.module';
import {
  DELIVERY_MAIL_CHECK_QCD,
  DELIVERY_MAIL_CHECK_TO_CHARITY,
  UNIT,
  isYearAfter2024,
} from '../../../settings/settings';
import classNames from 'classnames';
import styles from '../../Sell/SellFundEditor/DistributionAmount.module.scss';
import { kebabCase } from 'lodash';
import MultiInput from '../../Shared/MultiInput/MultiInput';
import { getDeliveryMethod } from '../../../redux/modules/sellDeliveryMethod/sellDeliveryMethod.selectors';
import qcdBeaconError from '../../../assets/images/qcd-beacon-error.png';
import {
  QCD_DAILY_MIN_MAX_MODAL,
  openModal,
} from '../../../redux/modules/modals/modals.module';

const CharityAmount = () => {
  const dispatch = useDispatch();
  const charities = useSelector(getCharitiesArray);
  const totalAmount = useSelector(getCharitiesTotalGrossAmount);
  const deliveryMethod = useSelector(getDeliveryMethod);
  let max;
  if (
    deliveryMethod === DELIVERY_MAIL_CHECK_TO_CHARITY ||
    deliveryMethod === DELIVERY_MAIL_CHECK_QCD
  ) {
    max = isYearAfter2024() ? 108000 : 105000;
  }
  return (
    <div className="charity-container">
      {charities.map((charity, i) => (
        <div className="charity" key={charity.charityID}>
          <h1 className="charity-name blocked_data">{charity.charityName}</h1>
          <h3 className="charity-amount">Charity Amount</h3>
          <div className="min-max-text">
            Min: $1 / Max:{' '}
            <button
              className="max-modal-button"
              onClick={() => {
                dispatch(openModal(QCD_DAILY_MIN_MAX_MODAL));
              }}
            >
              {currencyNoPrecision(max)}
            </button>
          </div>
          {totalAmount > max && (
            <div className="error-messaging">
              <img
                alt="qcdBeaconError"
                src={qcdBeaconError}
                className="qcdError"
              />{' '}
              <span className="qcdError-text blocked_data">
                Please set your allocation amounts to total no more than
                <span className="qcdError-text_underline blocked_data">
                  {currencyNoPrecision(max)}
                </span>
                .
              </span>
            </div>
          )}
          <div className="enter-amount">
            <MultiInput
              allowedUnits={[UNIT.DOLLARS]}
              applyBranding={false}
              ariaLabel={'Distribution Amount'}
              autoFocus={i === 0 ? true : false}
              className={classNames(
                'blocked_data',
                styles['distribution-amount-amount-input'],
                `e2e-input-field-${kebabCase(charity.charityID)}`
              )}
              defaultValue={charity?.grossAmountDollars || undefined}
              disabled={false}
              displayErrorMessage={
                (charity?.grossAmountDollars !== undefined &&
                  charity?.grossAmountDollars < 1) ||
                charity?.grossAmountDollars > max ||
                totalAmount > max
              }
              displayValidationMessage={
                (charity?.grossAmountDollars !== undefined &&
                  charity?.grossAmountDollars < 1) ||
                charity?.grossAmountDollars > max ||
                totalAmount > max
              }
              error={
                (charity?.grossAmountDollars !== undefined &&
                  charity?.grossAmountDollars < 1) ||
                charity?.grossAmountDollars > max ||
                totalAmount > max
              }
              errorClassName={`e2e-input-error e2e-input-error-${kebabCase(
                charity?.charityID
              )}`}
              id={charity?.charityID}
              inputID={`amt-${charity?.charityID}`}
              selectedInput={UNIT.DOLLARS}
              setFocus={true}
              //validationMessage={'10'}
              // onBlur={() => {
              //   updateSellFund({
              //     agreementID,
              //     inFocus: undefined,
              //   });
              // }}
              onInputChange={(amount) => {
                const grossAmountDollars = amount;
                dispatch(
                  AddGrossAmount({
                    ...charity,
                    grossAmountDollars,
                  })
                );
              }}
            />
          </div>
        </div>
      ))}
      <div className="total-amount blocked_data">
        Total Distribution Amount: {currency(totalAmount)}
      </div>
    </div>
  );
};

export default CharityAmount;
